<template>
  <div>
    <div class="form-container">
      <!-- row-1 -->
      <div class="checkbox-container">
        <p4a-checkbox
          :value="'isAutomaticProcedure'"
          :text="$t('folderProperties.procedure.form.checkbox')"
          :checked="procedure.AutoProcedureEnabled"
          :disabled="ReadOnly"
          @change="procedure.AutoProcedureEnabled = !procedure.AutoProcedureEnabled">
        </p4a-checkbox>
      </div>
      <!-- row-2 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.procedure.form.label1') }}<span class="form-row__colon">:</span></label>
        <select-drop-down
          :place-holder="procedure.template.selected"
          :items="procedure.template.items"
          :disabled="ReadOnly"
          @onchange="updateTemplate"
        />
      </div>
      <!-- row-3 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.procedure.form.label2') }}<span class="form-row__colon">:</span></label>
        <select-drop-down
          :place-holder="procedure.owner.selected"
          :items="procedure.owner.items"
          :disabled="ReadOnly"
          @onchange="updateOwner"
        />
      </div>
    </div>
  </div>
</template>

<script>
import selectDropDown from '../../dropdown/selectDropDown'

export default {
  components: { selectDropDown },
  props: {
    procedure: Object,
    ReadOnly: Boolean
  },
  data () {
    return {

    }
  },
  methods: {
    updateTemplate (newValue) {
      this.procedure.template.selected = newValue
    },
    updateOwner (newValue) {
      this.procedure.owner.selected = newValue
    }
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/folder/folderProperties/procedure.vue